type Props = {
  width?: string;
  height?: string;
  /** Filled when the thing it marks is pinned; an outline when it is not. */
  filled?: boolean;
};

/**
 * Pushpin — "remember this as the speaker's voice for the language" in the
 * dub picker rows. Uses currentColor so the button around it sets the colour.
 */
const PinIcon = ({ width = '14', height = '14', filled = false }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M5 1.5h4l-.5 1v3l2 2V8.5H7.5V13h-1V8.5H3.5V7.5l2-2v-3l-.5-1Z"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
  </svg>
);

export default PinIcon;
